import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { insertInitialMetaForFrame } from '@comeon/analytics';

import { selectSportsbookMaintenanceEnabled } from '../brand/ducks/index';
import SportsbookMaintenance from './sportsbook-maintenance';
import SportsbookSeoHeader from './sportsbook-seo-header';
import { LessThanLargeContainer } from '~/components/layout/mediaquery';
import SportsbookLobby from './sportsbook-products-async';
import useUpdateSportsbookLastProduct from './use-update-sportsbook-last-product';
import useSportsbookProduct from './use-sportsbook-product';
import SportsbookSeoLobbyHeaderContainer from './lobby/sportsbook-seo/sportsbook-seo-lobby-header-container';
import { AppDispatch } from '~/store/types';

type Props = {
	SmallerFooterSportsbookContainer?: React.ComponentType;
};

const SportsbookContainer: React.FC<Props> = ({ SmallerFooterSportsbookContainer }) => {
	const dispatch: AppDispatch = useDispatch();
	const showMaintenance = useSelector(selectSportsbookMaintenanceEnabled) as boolean;

	useUpdateSportsbookLastProduct();

	// Handle initial-meta pixel request
	const product = useSportsbookProduct() as string;
	useEffect(() => {
		insertInitialMetaForFrame(product, dispatch);
	}, [product, dispatch]);

	if (showMaintenance) {
		return (
			<>
				<SportsbookSeoHeader />
				<SportsbookMaintenance />
			</>
		);
	}

	return (
		<>
			<>
				<SportsbookSeoLobbyHeaderContainer />
				<SportsbookLobby />
			</>
			<LessThanLargeContainer>
				{SmallerFooterSportsbookContainer && <SmallerFooterSportsbookContainer />}
			</LessThanLargeContainer>
		</>
	);
};

export default SportsbookContainer;
